import { Button, Form, Select, Radio, Checkbox, RadioChangeEvent, Row, Col, Divider } from 'antd';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { addConnTypeBodySize, modifyConnTypeBodySize } from './fittingTypeSlice';
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

export default function AddConnBodySize({ connSizeId }: any): JSX.Element {
    const dispatch = useDispatch();
    const [isDisabled, setIsDisabled] = useState(false);

    const { setModelChangeBS, editBs, setEditBS, isPref, setisPref, prefData, setPrefData } = React.useContext(CommonContext) as CommonContextType;

    const [fileList, setFileList] = useState<any>();
    const [file, setFile] = useState<any>()
    const [form] = Form.useForm();
    const [body_size_array, setBodySizeArray] = useState([{}]);
    const [cat_array, setCatArray] = useState([{}]);
    // const [prefData, setPrefData] = useState<boolean>(false)
    // const [isPref, setisPref] = useState<boolean>(false)
    const BodySizes = useSelector((state: AppState) => state.BodySizes);
    const Category = useSelector((state: AppState) => state.Category);

    useEffect(() => {

        if (BodySizes.BodySize.length > 0) {
            const arr = BodySizes.BodySize.map((el: any) => ({ value: el.bodysize_value, label: el.bodysize_value }))
            // let data = JSON.parse(BodySizes.BodySize[0].bodysize_value);
            // const arr = data.map((el: any) => ({ value: JSON.stringify(el), name: JSON.stringify(el) }))
            setBodySizeArray(arr)
        }

        if (Category.CategoryArr.length > 0) {
            // const arr = Category.CategoryArr.map((el: any) => ({ value: el.id, label: el.category_name }))
            const filteredArray = Category.CategoryArr
                .filter(function (element) {
                    return element.category_code != 'PUMP';
                })
                .map(function (el) {
                    return { value: el.id, label: el.category_name };
                });
            setCatArray(filteredArray)
        }

    }, [BodySizes, Category]);

    React.useEffect(() => {
        if (connSizeId[1]?.id) {
            // if (editCategory?.id) 
            // setIsDisabled(editCategory.disabled)
            /*   setFileList([
                  {
                      name: connSizeId[1].img_url.split('/').pop(),
                      url: process.env.REACT_APP_AZURE_BLOB_STORAGE_API + connSizeId[1].img_url,
                  }
              ])
              setFile(null) */
            // form.setFieldsValue(connSizeId[1])
            if (connSizeId[1].preferential == true) {
                setisPref(true)
            } else {
                setisPref(false)
            }
            let idArray = connSizeId[1]?.body_size_cat.map((obj: any) => obj.category.id);
            form.setFieldsValue(Object.assign({ body_sizes: connSizeId[1]?.body_size }, { product_category: idArray }, connSizeId[1]))

            if (connSizeId[1].status == 'Released') {
                setPrefData(true);
            } else if (connSizeId[1].status == 'Not Released') {
                setPrefData(false)
            } else if (connSizeId[1].status == 'Under Construction') {
                setPrefData(false)
            }


        } else {
            setIsDisabled(false);
            // setFileList(null);
            // setFile(null);
            setPrefData(false);
            form.resetFields();
            form.setFieldsValue(null)
        }
    }, [connSizeId[1], form, editBs]);


    const onFinish = (values: any) => {
        values.body_size = values.body_sizes
        delete (values.body_sizes)
        values.con_type_con_size = connSizeId[0]?.id
        if (values?.preferential == true || values?.preferential == false) {
            values.preferential = values.preferential
        }
        /*  const formData = new FormData();
         formData.append('file', file);
         formData.append('body_size', values.body_sizes)
         formData.append('status', values.status)
         formData.append('con_type_con_size', connSizeId[0])
         if (values?.preferential == true || values?.preferential == false) {
             formData.append('preferential', values.preferential)
         } */


        if (connSizeId[1]?.id) {
            // formData.append('img_url', connSizeId[1]?.img_url)
            // formData.append('updated_datetime', new Date().toLocaleString() + "");
            values.updated_datetime = new Date().toLocaleString() + ""
            dispatch(modifyConnTypeBodySize(values, connSizeId[1]?.id))
        } else {

            // formData.append('created_datetime', new Date().toLocaleString() + "");
            values.created_datetime = new Date().toLocaleString() + ""
            dispatch(addConnTypeBodySize(values))
        }

        setModelChangeBS(false);
        form.resetFields();
        setEditBS(null)

    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    /*  const handleChange: UploadProps["onChange"] = ({ fileList: newFileList }) => {
         newFileList[0].status = 'done'
         setFile(newFileList[0].originFileObj)
         setFileList(newFileList);
     } */

    const onChange = (e: CheckboxChangeEvent) => {
        console.log(`checked = ${e.target.checked}`);
        if (e.target.checked == true) {
            setisPref(true);
        } else {
            setisPref(false);
        }
    };

    let onChange_split_nut = (e: CheckboxChangeEvent) => {
        console.log(`split nut checked = ${e.target.checked}`);
    };
    const onChangeSelect = (e: RadioChangeEvent) => {
        console.log("radio", e.target.value)
        if (e.target.value == 'Released') {
            setPrefData(true);
        } else if (e.target.value == 'Not Released') {
            setPrefData(false)
        } else if (e.target.value == 'Under Construction') {
            setPrefData(false)
        }


    };

    const props = {
        showUploadList: {
            showRemoveIcon: false,
            showPreviewIcon: false,
        },
    }
    return (
        <div>

<Divider style={{ borderColor: '#018B98', marginBottom: '6px'}} />
<span><b><u>Connection Size Details:</u></b></span>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%'}}>
                <div style={{ width: '25%' }}><b>Id:</b> {connSizeId[0].id} </div>
                <div style={{ width: '25%' }}><b>Code:</b>{connSizeId[0].conn_size.size_code}</div>
                <div style={{ width: '25%' }}><b>Name:</b> {connSizeId[0].conn_size.size_name}</div>
                <div style={{ width: '25%' }} className='sub_data_boxc'> <b>{connSizeId[0].measure_unit.unit} </b></div>
            </div>
            <Divider style={{ borderColor: '#018B98',marginTop: '10px' }} />

            {/* <h3>Read-only Information</h3>
        <p>Some text or data that you want to display as read-only</p> */}
            <Form
                form={form}
                layout={'vertical'}
                initialValues={{
                    // status: "Released",
                    preferential: false,
                    split_nut: false
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >

                {/* <Form.Item>
                <Upload.Dragger
                    {...props}
                    listType="picture-card"
                    fileList={fileList}
                    onChange={handleChange}
                    maxCount={1}
                    accept="image/*"
                >
                    <div>
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">Drag file to upload</p> Or Select file from your PC
                    </div>
                </Upload.Dragger>
            </Form.Item> */}

                <Form.Item label="Body Size"
                    name='body_sizes'
                    rules={[
                        {
                            required: true,
                            message: 'Please select body size',
                        },
                    ]}>
                    <Select //value={body_size}
                        options={body_size_array}>
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Product Category"
                    name="product_category"
                    rules={[
                        {
                            required: true,
                            message: "Please select Category",
                        }
                    ]}
                >
                    <Select mode="multiple"
                        options={cat_array}
                    />
                </Form.Item>

                <Form.Item
                    name='status'

                    rules={[
                        {
                            required: true,
                            message: "Please select Status",
                        }
                    ]}>
                    <Radio.Group onChange={onChangeSelect}>
                        <Radio value="Released">Released</Radio>
                        <Radio value="Not Released">Not Released</Radio>
                        <Radio value="Under Construction">Under Construction</Radio>
                    </Radio.Group>
                </Form.Item>

                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    {prefData ? <Col className="gutter-row" span={8}>
                        <div>
                            {/* {prefData ? */}
                            <Form.Item
                                name='preferential' valuePropName="checked">
                                <Checkbox onChange={onChange}>Preferential</Checkbox>
                            </Form.Item>
                            {/* : null} */}
                        </div>
                    </Col> : null}
                    <Col className="gutter-row" span={8}>
                        <div>

                            <Form.Item
                                name='split_nut' valuePropName="checked">
                                <Checkbox onChange={onChange_split_nut}>Split Nut</Checkbox>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>


                <Form.Item>
                    <Button className='submit-button' type="primary" htmlType="submit" >{connSizeId[1]?.id ? 'Update' : 'Create'}</Button>
                </Form.Item>
            </Form>
        </div>
    )
}
